<template scope="scope">
  <el-dialog title="审核机制设置" :visible.sync="dialogAuthFormVisible">
      <el-form style="margin-left:20px;" ref="configForm" :model="configForm" label-width="160px">
              <h3 >发布人工审核</h3>
             <el-radio-group v-model="configForm.goodsAuthSwitch" @change="updateUsedCarAuthSwitch()">
                <el-radio  :label="1">已关闭</el-radio>
                <el-radio :label="2">已开启</el-radio>
            </el-radio-group>
      </el-form>
    </el-dialog>

</template>

<script>
import Config from '@/framework/configs/Config'
import BasicPager from '@/mixins/BasicPager'
import JoinGoodsCarShowDialog from '@/pages/plusbusiness/children/JoinGoodsCarShowDialog'
import usedCarModel from '@/framework/models/usedCarModel'

export default {
  name: 'auth-goods-config',
  data () {
    return {
      configForm: {
        goodsAuthSwitch: 1
      },
      dialogAuthFormVisible: false
    }
  },
  methods: {
    showAuthPhone: function (id) {
      this.dialogAuthFormVisible = true
      let _this = this
      let param = { id: id }
      let listener = {
        success: function (dataInfo) {
          _this.configForm.goodsAuthSwitch = dataInfo.datas.goodsAuthSwitch
        }
      }
      usedCarModel.getChannelConfig(_this, param, listener)
    },

    updateUsedCarAuthSwitch: function () {
      let userInfo = localStorage.userInfo
      let id = null
      if (localStorage.userInfo) {
        userInfo = JSON.parse(localStorage.userInfo)
        id = userInfo.id
      }

      let _this = this
      let param = { 'id': id, 'goodsAuthSwitch': this.configForm.goodsAuthSwitch }
      let listener = {
        success: function (dataInfo) {
          if (dataInfo.success) {
            _this.$message({
              message: '修改成功！',
              type: 'success'
            })
          } else {
            _this.$message({
              message: '修改失败！',
              type: 'error'
            })
          }
        }
      }
      usedCarModel.changeChannelConfigAuthSwitch(_this, param, listener)
    },
    hideDialog () {
      this.dialogAuthFormVisible = false
    }
  }
}

</script>
